/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { fromJS } from 'immutable';

import {
  HIDE_MODAL,
  SET_MODAL_OPTIONS,
  SHOW_MODAL,
  MODAL_SENDING
} from './constants';
/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

const DEFAULT_OPTIONS = {
  backdropColor: 'rgba(39, 39, 39, 1)',
  renderContent: () => {},
  isCloseable: true,
  isOpen: false,
  maxWidth: null,
  padding: null,
  zIndex: 10,
};
const initalState = {
  isSending: false
}

const modalState = fromJS({
  options: DEFAULT_OPTIONS,
  ...initalState
});



function modalReducer(state = modalState, action) {
  const currentOptions = state.get('options').toJS();

  switch (action.type) {
    case HIDE_MODAL:
      return state.merge({
        ...initalState,
        options: DEFAULT_OPTIONS
      });
    case SET_MODAL_OPTIONS:
      return state.set(
        'options',
        fromJS({ ...currentOptions, ...action.options })
      );
    case SHOW_MODAL:
      return state.set(
        'options',
        fromJS({ ...currentOptions, ...action.options, isOpen: true })
      );
    case MODAL_SENDING:
      return state.set('isSending', fromJS(action.value));
    default:
      return state;
  }

}
/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default modalReducer;
